<template>
  <BaseFilter
    :title="`${itemModule.item} Filter`"
    :isChips="isChips"
    @submit="$emit('apply')"
    @reset="
      $emit('reset');
      formCounter++;
    "
    @filterDialogOpen="getItemOptions()"
    :isIcon="false"
  >
    <template #form>
      <v-row no-gutters :key="formCounter">
        <v-col cols="12" lg="12" xl="12" class="py-2">
          <span class="text-body-2 font-weight-bold text-capitalize">
            select storage type
          </span>
          <SelectField
            id="storage_type"
            name="storage_type"
            dense
            :multiple="true"
            hide-details
            outlined
            clearable
            label="select storage type"
            :itemsList="itemMasterStorageType"
            itemText="display_value"
            itemValue="value"
            :isSearchRequired="false"
            v-model="itemFilters.storage_type"
            :menu-props="{ offsetY: true }"
            class="pt-2"
            @change="itemFiltersChanged('storage_type', $event)"
          ></SelectField>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" lg="6" xl="6" class="pt-2">
          <span class="text-body-2 font-weight-bold text-capitalize pl-1">
            order by</span
          >
          <SelectField
            id="order_by"
            name="order_by"
            dense
            hide-details
            outlined
            clearable
            label="select value"
            :itemsList="orderBy"
            itemText="label"
            itemValue="value"
            :value="itemFilters.ordering"
            :menu-props="{ offsetY: true }"
            class="pt-2 pl-1"
            @change="itemFiltersChanged('ordering', $event)"
          >
          </SelectField>
        </v-col>
      </v-row>
    </template>
  </BaseFilter>
</template>

<script>
import BaseFilter from "@/components/BaseComponents/BaseFilter.vue";
import { bus } from "@/main";
import { mapState } from "vuex";
import { itemModule } from "@/utils/moduleMapping";

export default {
  components: {
    BaseFilter,
  },
  props: {
    isChips: Boolean,
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getItemOptions();
      }
    },
  },
  data() {
    return {
      itemModule,
      itemMasterStorageType: [],
      // itemMasterUnitType: [],
      orderBy: [
        { label: "Storage Type", value: "storage_type" },
        // { label: "Unit", value: "unit" },
      ],
      formCounter: 0,
    };
  },
  computed: {
    ...mapState("userProfile", {
      itemFilters: (state) => state.item_filters,
    }),
  },
  methods: {
    getItemOptions() {
      bus.$emit("showLoader", true);
      this.$api.item
        .getItemOptions({ request_type: "filter" })
        .then((res) => {
          this.itemMasterStorageType = res?.data?.storage_type;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    itemFiltersChanged(key, value) {
      let obj = {};
      obj[key] = value;
      this.$store.commit("userProfile/setFilters", {
        moduleKey: "item_filters",
        payload: obj,
      });
    },
    // getItemUnit() {
    //   bus.$emit("showLoader", true);
    //   this.$api.itemUnit
    //     .getItemUnitList({ limit: "all" })
    //     .then((res) => {
    //       this.itemMasterUnitType = res.data;
    //       bus.$emit("showLoader", false);
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //       bus.$emit("showLoader", false);
    //     });
    // },
  },
};
</script>
